
import { useRenderGuard } from 'apprise-frontend-core/utils/renderguard'
import { PropsWithChildren } from 'react'
import { useLoggedStore } from './store'



export const LoggedUserLoader = (props: PropsWithChildren) => {

    const store = useLoggedStore()

    const { content } = useRenderGuard({

        render: props.children,
        orRun: store.fetchLoggeduser

    })

    return content
}